import getters from './getters';
import mutations from './mutations';

export default {
  suffix: 'tierratv',
  state: () => ({
    filterAttribute: undefined
  }),
  getters,
  mutations
};
